import styled from '@emotion/styled';
export const EmbedSizeSection = styled.div `
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 10px;
  padding: 0 2px 2px;
`;
export const EmbedSizeRadioButtonWrapper = styled.div `
  position: relative;
  flex: 0 1 118px;
  color: var(--player-modal-font-color);

  input:checked ~ label {
    outline: 2px solid var(--primary);
  }
`;
export const EmbedSizeImage = styled.img `
  height: 86px;
  width: 46px;
  margin-bottom: 13px;
`;
export const EmbedSizeRadioButton = styled.input `
  position: absolute;
  opacity: 0;
  margin: 0;
`;
export const EmbedSizeRadioButtonLabel = styled.label `
  height: 157px;
  background: var(--player-modal-background, var(--gray2));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 2.69px 2.69px #00000040,
    0 0.67px 6.05px #00000040;
  border-radius: 4px;

  span {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
  }
`;
